export const TinyMCEProductionKey = "T7LK763AAA965B3126D2F4B7321FD1A797E2F022131531ACFB85C026FD16D7B3";
export const TinyMCEDevelopmentKey = "T7LK998E7E9CDCC2A3AFD8BFD76FC5271938F90DD303412063DCC93599B50DC2";
